import { useCallback, type ComponentProps } from "react";

import { PropertiesPanelSection } from "@skilitics/designer-ui-components";
import { useFormatMessage } from "@skilitics/localization";

import { useEditingCss } from "./EditingCssPropertiesContext";
import { OverflowPicker } from "./OverflowPicker";

export const OverflowProperties = () => {
  const formatMessage = useFormatMessage(formatStrings);
  const { cssProperties, onCssPropertiesChange } = useEditingCss();

  const handleOverflowChange: ComponentProps<typeof OverflowPicker>["onOverflowChange"] = useCallback(
    ({ overflowX, overflowY }) => {
      onCssPropertiesChange({
        overflowX,
        overflowY,
      });
    },
    [onCssPropertiesChange],
  );

  return (
    <PropertiesPanelSection title={formatMessage("sectionHeading")} helperText={formatMessage("sectionHelperText")}>
      <OverflowPicker
        onOverflowChange={handleOverflowChange}
        overflowX={cssProperties.overflowX}
        overflowY={cssProperties.overflowY}
      />
    </PropertiesPanelSection>
  );
};

const formatStrings = {
  sectionHeading: {
    en: "Overflow Behavior",
  },
  sectionHelperText: {
    en: "How should items that overflow the container behave?",
  },
};
